var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('autocomplete-product', _vm._b({
    ref: "autocomplete-product",
    on: {
      "input": _vm.emit
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref) {
        var parent = _ref.parent,
          item = _ref.item,
          attrs = _ref.attrs;
        return [_c('v-chip', _vm._b({
          key: item._id,
          attrs: {
            "outlined": "",
            "label": "",
            "close": ""
          },
          on: {
            "click:close": function ($event) {
              return parent.selectItem(item);
            }
          }
        }, 'v-chip', attrs, false), [_vm._v(_vm._s(_vm.itemText(item)))])];
      }
    }]),
    model: {
      value: _vm.form.usage.target._products,
      callback: function ($$v) {
        _vm.$set(_vm.form.usage.target, "_products", $$v);
      },
      expression: "form.usage.target._products"
    }
  }, 'autocomplete-product', Object.assign({}, _vm.attrs_input__console, {
    dense: false,
    label: '사용대상 ' + _vm.USAGE_TARGET_TYPES.PRODUCTS.text,
    multiple: true,
    // params: { _seller: { $in: _seller } },
    itemText: _vm.itemText,
    params: _vm.params
  }), false));

}
var staticRenderFns = []

export { render, staticRenderFns }